module.exports = __webpack_public_path__ + "static/media/datacult-logo.9cc09f43.png";